import React from 'react';

const Arrow = () => (
  <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.76237 0.772633L13.6071 10.6832L0.16229 14.0354L3.76237 0.772633Z" fill="#14E0C2" />
  </svg>
);

export { Arrow };
